/* eslint-disable unicorn/filename-case */
/* eslint-disable unicorn/better-regex */
/* eslint-disable unicorn/filename-case */
/* eslint-disable unicorn/prefer-switch */
/* eslint-disable unicorn/prevent-abbreviations */
import 'draft-js/dist/Draft.css'; // Import Draft.js default styles
import './FormulaBarIntellisense.css'; // Import your custom styles
import { useDispatch, useSelector } from 'react-redux';
import {
  Editor,
  EditorState,
  RichUtils,
  CompositeDecorator,
  Modifier,
  Entity,
  ContentState,
  convertToRaw,
} from 'draft-js';
import { Text, Box, Flex, Button, Link, Tooltip } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useState, useRef, useEffect, useMemo, useCallback } from 'react';

import {
  FetchBlockOutputs,
  FetchPlannerBlockMetadata,
  getBaseScenario,
  getFormulaList,
  getPlannerBlock,
  getSelectedIndicators,
  UpdateIndicatorFormula,
} from 'redux/PlannerModeSlice';
// import { fetchBuilderBlockMetadata } from 'redux/BuilderModeSlice';
import FunctionIconComponent from 'components/Icons/FunctionIcon';
import QuestionIcon from 'components/Icons/QuestionIcon';
import useFormulaWorker from 'hooks/useFormulaWorker';
import { generateDataHash, SimpleCache } from 'utils/hashUtils';

const DraftJSFormula2 = ({ setIsExpanded, isExpanded }) => {
  const dispatch = useDispatch();
  const { blockId } = useParams();
  const [message, setMessage] = useState({ type: '', text: '', errorStatus: false });
  const [functions, setFunctions] = useState([]);
  const [dimensionFormula, setDimensionFormula] = useState([]);
  const [dimensionItemsFormula, setDimensionItemsFormula] = useState([]);
  // const [dimensionValuesFormula, setDimensionValuesFormula] = useState([]);
  const [currBlockIndicator, setCurrBlockIndicator] = useState([]);
  const [otherBlocks, setOtherBlocks] = useState([]);
  // const [suggestions, setSuggestions] = useState([]);
  const formulaList = useSelector(getFormulaList);
  const baseScenario = useSelector(getBaseScenario);
  const plannerBlock = useSelector(getPlannerBlock);
  const [suggestionsList, setSuggestionsList] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionBoxStyle] = useState({});
  const editorRef = useRef(null);
  const editorContainerRef = useRef(null);
  const selectedIndicators = useSelector(getSelectedIndicators);
  const cleanString = (str) => str?.replace(/\s+/g, ' ').trim();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [initialDecorator, setInitialDecorator] = useState([]);

  // Initialize worker
  const { processFormulaData, isWorkerAvailable } = useFormulaWorker();

  // State for worker-processed data
  const [workerData, setWorkerData] = useState(null);
  const [isWorkerProcessing, setIsWorkerProcessing] = useState(false);

  // Local cache for regex patterns to avoid regeneration
  const regexCache = useRef(new SimpleCache(20));

  // Build worker input and a stable signature based on nested values so
  // the effect can react to inner changes even if the outer reference is stable
  const workerInputFromFormula = formulaList
    ? {
        functions:
          formulaList?.functions?.map((fn) => ({
            name: cleanString(fn),
            type: 'function',
          })) || [],
        otherBlocks:
          formulaList?.blocks
            ?.filter((item) => item?.id !== Number(blockId))
            ?.flatMap((data) =>
              data?.indicators?.map((indicator) => ({
                blockname: cleanString(data.name),
                indicator: cleanString(indicator.name),
                type: 'othersblockIndicator',
              })),
            ) || [],
        dimensionFormula:
          formulaList.dimensions?.flatMap((dimension) =>
            dimension.properties.map((propertie) => ({
              dimName: cleanString(dimension.name),
              dimPropertie: cleanString(propertie.name),
              type: 'dimension',
            })),
          ) || [],
        dimensionItemsFormula:
          formulaList.dimensions?.flatMap((dimension) =>
            dimension.items.map((item) => ({
              dimName: cleanString(dimension.name),
              dimItem: cleanString(item.name),
              type: 'dimensionItem',
            })),
          ) || [],
        currBlockIndicator:
          formulaList?.blocks
            ?.filter((item) => item?.id === Number(blockId))?.[0]
            ?.indicators?.map((item) => ({
              indName: cleanString(item.name),
              type: 'currentBlockIndicator',
            })) || [],
      }
    : null;
  const formulaSignature = workerInputFromFormula ? generateDataHash(workerInputFromFormula) : null;

  // Clear cache when switching block context to avoid cross-block reuse
  useEffect(() => {
    regexCache.current.clear();
  }, [blockId]);

  useEffect(() => {
    editorRef.current.blur();
    const updateData = async () => {
      if (workerInputFromFormula) {
        // Use precomputed worker input and signature
        const workerInput = workerInputFromFormula;
        const dataHash = formulaSignature;
        // Check local cache first
        if (regexCache.current.has(dataHash)) {
          const cachedData = regexCache.current.get(dataHash);
          setWorkerData(cachedData);
          setFunctions(cachedData.suggestions.filter((s) => s.type === 'function'));
          setOtherBlocks(cachedData.suggestions.filter((s) => s.type === 'othersblockIndicator'));
          setDimensionFormula(cachedData.suggestions.filter((s) => s.type === 'dimension'));
          setDimensionItemsFormula(
            cachedData.suggestions.filter((s) => s.type === 'dimensionItem'),
          );
          setCurrBlockIndicator(
            cachedData.suggestions.filter((s) => s.type === 'currentBlockIndicator'),
          );
          return;
        }

        // Try to process with worker first
        if (isWorkerAvailable()) {
          try {
            setIsWorkerProcessing(true);
            const result = await processFormulaData(workerInput);
            // Cache the result
            regexCache.current.set(dataHash, result);

            // Limit cache size to prevent memory issues
            if (regexCache.current.size > 20) {
              const firstKey = regexCache.current.keys().next().value;
              regexCache.current.delete(firstKey);
            }

            setWorkerData(result);
            // Update local state with worker results
            setFunctions(result.suggestions.filter((s) => s.type === 'function'));
            setOtherBlocks(result.suggestions.filter((s) => s.type === 'othersblockIndicator'));
            setDimensionFormula(result.suggestions.filter((s) => s.type === 'dimension'));
            setDimensionItemsFormula(result.suggestions.filter((s) => s.type === 'dimensionItem'));
            setCurrBlockIndicator(
              result.suggestions.filter((s) => s.type === 'currentBlockIndicator'),
            );
          } catch {
            // Fallback to synchronous processing
            setFunctions(workerInput.functions);
            setOtherBlocks(workerInput.otherBlocks);
            setDimensionFormula(workerInput.dimensionFormula);
            setDimensionItemsFormula(workerInput.dimensionItemsFormula);
            setCurrBlockIndicator(workerInput.currBlockIndicator);
          } finally {
            setIsWorkerProcessing(false);
          }
        } else {
          // Fallback to synchronous processing if worker is not available
          setFunctions(workerInput.functions);
          setOtherBlocks(workerInput.otherBlocks);
          setDimensionFormula(workerInput.dimensionFormula);
          setDimensionItemsFormula(workerInput.dimensionItemsFormula);
          setCurrBlockIndicator(workerInput.currBlockIndicator);
        }
      }
    };

    updateData();
  }, [formulaSignature, processFormulaData, isWorkerAvailable]);

  // Memoize combined data calculation
  const combinedDatass = useMemo(() => {
    if (!formulaList || typeof formulaList !== 'object') return [];

    // --- Functions ---
    const func =
      Array.isArray(formulaList?.functions) && formulaList.functions.length > 0
        ? formulaList.functions.map((fn) => ({
            name: cleanString(fn),
            type: 'function',
          }))
        : [];

    // --- Other Blocks Indicators ---
    const othersBlocksIndicator = Array.isArray(formulaList?.blocks)
      ? formulaList.blocks.filter((item) => item?.id !== Number(blockId))
      : [];

    const othersBlocksFormulaData =
      othersBlocksIndicator.length > 0
        ? othersBlocksIndicator.flatMap((data) =>
            Array.isArray(data?.indicators)
              ? data.indicators.map((indicator) => ({
                  blockname: cleanString(data?.name),
                  indicator: cleanString(indicator?.name),
                  type: 'othersblockIndicator',
                }))
              : [],
          )
        : [];

    // --- Dimensions Properties ---
    const dimensionsFormulaData = Array.isArray(formulaList?.dimensions)
      ? formulaList.dimensions.flatMap((dimension) =>
          Array.isArray(dimension?.properties)
            ? dimension.properties.map((propertie) => ({
                dimName: cleanString(dimension?.name),
                dimPropertie: cleanString(propertie?.name),
                type: 'dimension',
              }))
            : [],
        )
      : [];

    // --- Dimensions Items ---
    const dimensionsFormulaItemsData = Array.isArray(formulaList?.dimensions)
      ? formulaList.dimensions.flatMap((dimension) =>
          Array.isArray(dimension?.items)
            ? dimension.items.map((item) => ({
                dimName: cleanString(dimension?.name),
                dimItem: cleanString(item?.name),
                type: 'dimensionItem',
              }))
            : [],
        )
      : [];

    // --- Current Block Indicators ---
    const currentBlock = Array.isArray(formulaList?.blocks)
      ? formulaList.blocks.filter((item) => item?.id === Number(blockId))
      : [];

    const currentBlockIndicator =
      currentBlock.length > 0 && Array.isArray(currentBlock[0]?.indicators)
        ? currentBlock[0].indicators.map((item) => ({
            indName: cleanString(item?.name),
            type: 'currentBlockIndicator',
          }))
        : [];

    // --- Collect All ---
    const result = [
      ...(Array.isArray(func) ? func.map((item) => cleanString(item?.name)) : []),
      ...(Array.isArray(othersBlocksFormulaData)
        ? othersBlocksFormulaData.flatMap((item) => [
            cleanString(item?.blockname),
            cleanString(item?.indicator),
          ])
        : []),
      ...(Array.isArray(dimensionsFormulaData)
        ? dimensionsFormulaData.flatMap((item) => [
            cleanString(item?.dimName),
            cleanString(item?.dimPropertie),
          ])
        : []),
      ...(Array.isArray(dimensionsFormulaItemsData)
        ? dimensionsFormulaItemsData.flatMap((item) => [
            cleanString(item?.dimName),
            cleanString(item?.dimItem),
          ])
        : []),
      ...(Array.isArray(currentBlockIndicator)
        ? currentBlockIndicator.map((item) => cleanString(item?.indName))
        : []),
    ];

    // --- Deduplicate for performance ---
    return Array.from(new Set(result));
  }, [formulaList, blockId]);

  // Use worker data for suggestions when available, fallback to local computation
  const suggestions = useMemo(() => {
    if (workerData?.suggestions) {
      return workerData.suggestions;
    }

    return [
      ...(functions?.map(({ name, type }) => ({ name, type })) || []),
      ...(otherBlocks?.map(({ blockname, indicator, type }) => ({ blockname, indicator, type })) ||
        []),
      ...(dimensionFormula?.map(({ dimName, dimPropertie, type }) => ({
        dimName,
        dimPropertie,
        type,
      })) || []),
      ...(dimensionItemsFormula?.map(({ dimName, dimItem, type }) => ({
        dimName,
        dimItem,
        type,
      })) || []),
      ...(currBlockIndicator?.map(({ indName, type }) => ({ indName, type })) || []),
    ];
  }, [
    workerData?.suggestions,
    functions,
    otherBlocks,
    dimensionFormula,
    currBlockIndicator,
    dimensionItemsFormula,
  ]);
  // Escape regex special chars
  const escapeRegExp = (string) => (string ? string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '');

  /**
   * Build a single combined regex ONCE from the terms list
   * @param {string[]} terms
   */
  const buildCombinedRegex = (terms) => {
    const filtered = terms.filter(Boolean).map((term) => escapeRegExp(term));

    if (filtered.length === 0) return null;

    // Sort longer first → avoids partial matches stealing precedence
    filtered.sort((a, b) => b.length - a.length);

    // Words with spaces/symbols → no \b anchors
    const patterns = filtered.map((t) => (/\s/.test(t) ? t : `\\b${t}\\b`));

    return new RegExp(`(${patterns.join('|')})(?: \\(\\d+\\))?`, 'gi');
  };

  // Use worker data for combined regex when available, fallback to local computation
  const combinedRegexGlobal = useMemo(() => {
    // FIXED: Wait for worker data instead of building locally
    if (isWorkerProcessing) {
      return null; // Return null while worker is processing
    }

    if (workerData?.regexPatterns?.combinedRegexGlobal) {
      return new RegExp(workerData.regexPatterns.combinedRegexGlobal, 'gi');
    }

    // FIXED: Only build locally if worker is not available AND we have small data
    if (combinedDatass?.length > 100) {
      return null; // Wait for worker data for large datasets
    }

    const result = buildCombinedRegex(combinedDatass);
    return result;
  }, [
    workerData?.regexPatterns?.combinedRegexGlobal,
    combinedDatass,
    isWorkerProcessing, // FIXED: Add worker processing state as dependency
  ]);

  const findWithRegex = (regex, contentBlock, callback) => {
    const text = contentBlock.getText();

    // FIXED: Handle case when combinedRegexGlobal is null (waiting for worker data)
    if (!combinedRegexGlobal) {
      return; // Skip regex matching until worker data arrives
    }

    // If we have a big list regex, combine it with custom regex
    const combinedRegex = combinedRegexGlobal
      ? new RegExp(`${combinedRegexGlobal.source}|${regex.source}`, 'gi')
      : new RegExp(regex.source, 'gi');

    let matchArr = combinedRegex.exec(text);
    while (matchArr) {
      const start = matchArr.index;
      const end = start + matchArr[0].length;
      callback(start, end);
      matchArr = combinedRegex.exec(text);
    }
  };

  useEffect(() => {
    if (isExpanded === false) {
      setShowSuggestions(false);
    }
    if (selectedIndicators) {
      setShowSuggestions(false);
    }
  }, [isExpanded, selectedIndicators]);

  // Use worker data for regex patterns when available, fallback to local computation
  const functionRegex = useMemo(() => {
    if (workerData?.regexPatterns?.functionRegex) {
      return new RegExp(workerData.regexPatterns.functionRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!functions || functions.length === 0) return null;
    const sortedItems = functions
      .map((f) => f.name)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.functionRegex, functions]);

  const blocknameRegex = useMemo(() => {
    if (workerData?.regexPatterns?.blocknameRegex) {
      return new RegExp(workerData.regexPatterns.blocknameRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!otherBlocks || otherBlocks.length === 0) return null;
    const sortedItems = otherBlocks
      .map((f) => f.blockname)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.blocknameRegex, otherBlocks]);

  const indicatorRegex = useMemo(() => {
    if (workerData?.regexPatterns?.indicatorRegex) {
      return new RegExp(workerData.regexPatterns.indicatorRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!otherBlocks || otherBlocks.length === 0) return null;
    const sortedItems = otherBlocks
      .map((f) => f.indicator)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.indicatorRegex, otherBlocks]);

  const dimensionRegex = useMemo(() => {
    if (workerData?.regexPatterns?.dimensionRegex) {
      return new RegExp(workerData.regexPatterns.dimensionRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!dimensionFormula || dimensionFormula.length === 0) return null;
    const sortedItems = dimensionFormula
      .map((f) => f.dimName)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.dimensionRegex, dimensionFormula]);

  const dimensionPropertyRegex = useMemo(() => {
    if (workerData?.regexPatterns?.dimensionPropertyRegex) {
      return new RegExp(workerData.regexPatterns.dimensionPropertyRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!dimensionFormula || dimensionFormula.length === 0) return null;
    const sortedItems = dimensionFormula
      .map((f) => f.dimPropertie)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.dimensionPropertyRegex, dimensionFormula]);

  const dimensionNameRegex = useMemo(() => {
    if (workerData?.regexPatterns?.dimensionNameRegex) {
      return new RegExp(workerData.regexPatterns.dimensionNameRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!dimensionItemsFormula || dimensionItemsFormula.length === 0) return null;
    const sortedItems = dimensionItemsFormula
      .map((f) => f.dimName)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.dimensionNameRegex, dimensionItemsFormula]);

  const dimensionItemRegex = useMemo(() => {
    if (workerData?.regexPatterns?.dimensionItemRegex) {
      return new RegExp(workerData.regexPatterns.dimensionItemRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!dimensionItemsFormula || dimensionItemsFormula.length === 0) return null;
    const sortedItems = dimensionItemsFormula
      .map((f) => f.dimItem)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.dimensionItemRegex, dimensionItemsFormula]);

  const currBlockIndicatorRegex = useMemo(() => {
    if (workerData?.regexPatterns?.currBlockIndicatorRegex) {
      return new RegExp(workerData.regexPatterns.currBlockIndicatorRegex, 'gi');
    }
    // Fallback to local regex compilation
    if (!currBlockIndicator || currBlockIndicator.length === 0) return null;
    const sortedItems = currBlockIndicator
      .map((f) => f.indName)
      .map((item) => escapeRegExp(item))
      .sort((a, b) => b.length - a.length)
      .join('|');
    return new RegExp(`\\b(${sortedItems})(?: \\(\\d+\\))?(?=\\W|$)`, 'gi');
  }, [workerData?.regexPatterns?.currBlockIndicatorRegex, currBlockIndicator]);

  // Simplified strategy functions that use pre-compiled regex
  const functionStrategy = (contentBlock, callback) => {
    if (functionRegex && combinedRegexGlobal) {
      findWithRegex(functionRegex, contentBlock, callback);
    }
  };

  const blocknameStrategy = (contentBlock, callback) => {
    if (blocknameRegex && combinedRegexGlobal) {
      findWithRegex(blocknameRegex, contentBlock, callback);
    }
  };

  const indicatorStrategy = (contentBlock, callback) => {
    if (indicatorRegex && combinedRegexGlobal) {
      findWithRegex(indicatorRegex, contentBlock, callback);
    }
  };

  const dimensionStrategy = (contentBlock, callback) => {
    if (dimensionRegex && combinedRegexGlobal) {
      findWithRegex(dimensionRegex, contentBlock, callback);
    }
  };

  const dimensionPropertyStrategy = (contentBlock, callback) => {
    if (dimensionPropertyRegex && combinedRegexGlobal) {
      findWithRegex(dimensionPropertyRegex, contentBlock, callback);
    }
  };

  const dimensionNameStrategy = (contentBlock, callback) => {
    if (dimensionNameRegex && combinedRegexGlobal) {
      findWithRegex(dimensionNameRegex, contentBlock, callback);
    }
  };

  const dimensionItemStrategy = (contentBlock, callback) => {
    if (dimensionItemRegex && combinedRegexGlobal) {
      findWithRegex(dimensionItemRegex, contentBlock, callback);
    }
  };

  const currBlockIndicatorStrategy = (contentBlock, callback) => {
    if (currBlockIndicatorRegex && combinedRegexGlobal) {
      findWithRegex(currBlockIndicatorRegex, contentBlock, callback);
    }
  };

  const FunctionSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState?.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `function-${type}`;

    return <span className={className}>{children}</span>;
  };

  const BlocknameSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState?.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `blockname-${type}`;
    return <span className={className}>{children}</span>;
  };

  const IndicatorSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState?.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `indicator-${type}`;
    return <span className={className}>{children}</span>;
  };
  const DimensionSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState?.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `dimeItem-${type}`;
    return <span className={className}>{children}</span>;
  };
  const DimensionPropertySpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `dimProperty-${type}`;
    return <span className={className}>{children}</span>;
  };
  const DimensionItemSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `dimItem-${type}`;
    return <span className={className}>{children}</span>;
  };

  const currBlockIndicatorSpan = (props) => {
    const { contentState, entityKey, children } = props;
    if (!entityKey) {
      return <span>{children}</span>;
    }
    const entity = contentState?.getEntity(entityKey); // This line may be causing the error
    const { type } = entity.data;
    const className = `currBlockIndicator-${type}`;
    return <span className={className}>{children}</span>;
  };

  // Memoize decorator strategies to prevent recalculation
  const decoratorStrategies = useMemo(() => {
    // FIXED: Incremental strategy building - no conditions, build as data arrives
    const hasFunctions = functions.length > 0;
    const hasOtherBlocks = otherBlocks.length > 0;
    const hasDimensions = dimensionFormula.length > 0;
    const hasCurrBlockIndicator = currBlockIndicator.length > 0;
    const hasDimensionItems = dimensionItemsFormula.length > 0;

    // FIXED: Incremental strategy building - add strategies as data arrives without recalculating existing ones
    const strategies = {};

    // Build strategies incrementally for each available data type
    if (hasFunctions) {
      strategies.function = [
        {
          strategy: functionStrategy,
          component: FunctionSpan,
        },
      ];
    }

    if (hasOtherBlocks) {
      strategies.othersblockIndicator = [
        {
          strategy: blocknameStrategy,
          component: BlocknameSpan,
        },
        {
          strategy: indicatorStrategy,
          component: IndicatorSpan,
        },
      ];
    }

    if (hasDimensions) {
      strategies.dimension = [
        {
          strategy: dimensionStrategy,
          component: DimensionSpan,
        },
        {
          component: DimensionPropertySpan,
          strategy: dimensionPropertyStrategy,
        },
      ];
    }

    if (hasDimensionItems) {
      strategies.dimensionItem = [
        {
          strategy: dimensionNameStrategy,
          component: DimensionSpan,
        },
        {
          component: DimensionItemSpan,
          strategy: dimensionItemStrategy,
        },
      ];
    }

    if (hasCurrBlockIndicator) {
      strategies.currentBlockIndicator = [
        {
          strategy: currBlockIndicatorStrategy,
          component: currBlockIndicatorSpan,
        },
      ];
    }

    return strategies;
  }, [
    // FIXED: Use JSON.stringify for deep comparison to prevent unnecessary rebuilds
    JSON.stringify({
      functions: functions.map((f) => f.name || f),
      otherBlocks: otherBlocks.map((b) => b.blockname + b.indicator),
      dimensionFormula: dimensionFormula.map((d) => d.dimName + d.dimPropertie),
      currBlockIndicator: currBlockIndicator.map((c) => c.name || c),
      dimensionItemsFormula: dimensionItemsFormula.map((d) => d.dimName + d.dimItem),
    }),
  ]);
  const extractStrategies = (decorator) =>
    // eslint-disable-next-line no-underscore-dangle
    decorator?._decorators?.map(({ strategy, component }) => ({
      strategy,
      component,
    })) || [];

  const createCombinedDecorator = (types) => {
    // Create a stable key for caching
    const typesKey = Array.isArray(types) ? types.sort().join(',') : types;

    // Check if we already have this decorator cached
    if (createCombinedDecorator.cache && createCombinedDecorator.cache[typesKey]) {
      return createCombinedDecorator.cache[typesKey];
    }

    const currentStrategies = extractStrategies(editorState.getDecorator());
    const initialStrategies = extractStrategies(initialDecorator);

    // Handle both single type and array of types
    let newStrategies = [];
    if (Array.isArray(types)) {
      // If types is an array, collect strategies from all types
      types.forEach((type) => {
        if (decoratorStrategies[type]) {
          newStrategies = newStrategies.concat(decoratorStrategies[type]);
        }
      });
    } else {
      // If types is a single type
      newStrategies = decoratorStrategies[types] || [];
    }

    // Merge: initial → new → current
    const combinedStrategies = initialStrategies.concat(newStrategies, currentStrategies);

    const decorator = new CompositeDecorator(combinedStrategies);

    // Cache the decorator
    if (!createCombinedDecorator.cache) createCombinedDecorator.cache = {};
    createCombinedDecorator.cache[typesKey] = decorator;

    // Limit cache size to prevent memory issues
    const cacheKeys = Object.keys(createCombinedDecorator.cache);
    if (cacheKeys.length > 20) {
      delete createCombinedDecorator.cache[cacheKeys[0]];
    }

    return decorator;
  };

  // Memoize the createCombinedDecorator function to prevent unnecessary calls
  const memoizedCreateCombinedDecorator = useCallback(
    (types) => {
      return createCombinedDecorator(types);
    },
    [decoratorStrategies], // FIXED: Only depend on decoratorStrategies
  );

  // Memoize entity creation to prevent recreation on every call
  const createEntity = useCallback((type) => {
    const entityKey = Entity.create('TYPE', 'MUTABLE', { type });
    return entityKey;
  }, []);
  const [tooltipContent, setTooltipContent] = useState('');

  // Memoize the formula processing logic
  const processFormulaDataFromIndicators = useCallback((indicators) => {
    if (!indicators?.formula) return null;

    const data = indicators.formula.replace(/["']/g, '');
    const formulaParsing = indicators?.calculated_formula?.formula_map || [];

    return { data, formulaParsing };
  }, []);

  // Memoize the content state creation
  const createContentStateWithEntities = useCallback(
    (data, formulaParsing) => {
      if (!data) return null;

      let contentState = ContentState.createFromText('');
      let selection = contentState.getSelectionAfter();
      let startOffset = 0;
      let remainingText = data;

      // Process each suggestion more efficiently
      formulaParsing.forEach((suggestion) => {
        const textToInsert = suggestion.name;
        const entityKey = createEntity(suggestion.type);

        const matchIndex = remainingText.toLowerCase().indexOf(textToInsert.toLowerCase());
        if (matchIndex !== -1) {
          // Insert unmatched text before the match
          const unmatchedText = remainingText.slice(0, matchIndex);
          if (unmatchedText) {
            selection = selection.merge({
              anchorOffset: startOffset,
              focusOffset: startOffset,
            });
            contentState = Modifier.insertText(contentState, selection, unmatchedText);
            startOffset += unmatchedText.length;
          }

          // Insert matched text with entity
          selection = selection.merge({
            anchorOffset: startOffset,
            focusOffset: startOffset,
          });
          contentState = Modifier.insertText(
            contentState,
            selection,
            textToInsert,
            null,
            entityKey,
          );
          startOffset += textToInsert.length;

          // Update remaining text
          remainingText = remainingText.slice(matchIndex + textToInsert.length);
        }
      });

      // Insert remaining unmatched text
      if (remainingText.length > 0) {
        selection = selection.merge({
          anchorOffset: startOffset,
          focusOffset: startOffset,
        });
        contentState = Modifier.insertText(contentState, selection, remainingText);
      }

      return { contentState, finalOffset: startOffset + remainingText.length };
    },
    [createEntity],
  );

  // FIXED: Use useRef for caching to avoid self-reference issues
  const decoratorCacheRef = useRef({});

  // Memoize decorator creation with stable dependencies
  const memoizedDecorator = useMemo(() => {
    // FIXED: Calculate types directly to avoid circular dependency
    if (!selectedIndicators?.calculated_formula?.formula_map) {
      return null;
    }

    const formulaMap = selectedIndicators.calculated_formula.formula_map;
    const types = [...new Set(formulaMap.map((f) => f.Type || f.type))];

    if (types.length === 0) {
      return null;
    }

    // Check if decorator strategies are available
    if (!decoratorStrategies || Object.keys(decoratorStrategies).length === 0) {
      return null;
    }

    // Create a stable key for the decorator
    const decoratorKey = types.sort().join(',');

    // FIXED: Use the ref for caching instead of self-reference
    if (decoratorCacheRef.current[decoratorKey]) {
      return decoratorCacheRef.current[decoratorKey];
    }

    const decorator = memoizedCreateCombinedDecorator(types);

    // FIXED: Cache the decorator using the ref
    decoratorCacheRef.current[decoratorKey] = decorator;

    // Limit cache size
    const cacheKeys = Object.keys(decoratorCacheRef.current);
    if (cacheKeys.length > 10) {
      delete decoratorCacheRef.current[cacheKeys[0]];
    }

    return decorator;
  }, [
    // FIXED: Only depend on essential values, no circular dependencies
    selectedIndicators?.calculated_formula?.formula_map?.length || 0,
    selectedIndicators?.calculated_formula?.formula_map
      ?.map((item) => item.Type || item.type)
      .sort()
      .join('|') || '',
    Object.keys(decoratorStrategies).length,
    memoizedCreateCombinedDecorator,
  ]);

  useEffect(() => {
    if (
      !selectedIndicators ||
      !decoratorStrategies ||
      Object.keys(decoratorStrategies).length === 0
    ) {
      return;
    }

    // Check if formula is empty and clear editor state if so
    if (!selectedIndicators.formula || selectedIndicators.formula.trim() === '') {
      // Clear editor state to empty
      const emptyContentState = ContentState.createFromText('');
      const emptyEditorState = EditorState.createWithContent(emptyContentState);
      setEditorState(emptyEditorState);
      setTooltipContent(null);
      setMessage({ type: '', text: '', errorStatus: false });
      return;
    }

    // Clear any existing timeout
    const timeoutId = setTimeout(() => {
      // Process formula data
      const processedData = processFormulaDataFromIndicators(selectedIndicators);
      if (!processedData) {
        return;
      }

      const { data, formulaParsing } = processedData;

      setTooltipContent(data);
      setMessage({ type: '', text: '', errorStatus: false });

      // If no parsing metadata is available, render the raw data as plain text
      if (!Array.isArray(formulaParsing) || formulaParsing.length === 0) {
        const plainContentState = ContentState.createFromText(data || '');
        const plainEditorState = EditorState.push(
          editorState,
          plainContentState,
          'insert-characters',
        );

        if (memoizedDecorator) {
          if (JSON.stringify(editorState.getDecorator()) !== JSON.stringify(memoizedDecorator)) {
            setInitialDecorator(memoizedDecorator);
            setEditorState(EditorState.set(plainEditorState, { decorator: memoizedDecorator }));
          } else {
            setEditorState(plainEditorState);
          }
        } else {
          setEditorState(plainEditorState);
        }

        if (editorRef.current) {
          editorRef.current.blur();
        }
        return;
      }

      // Create content state with entities
      const contentStateResult = createContentStateWithEntities(data, formulaParsing);
      if (!contentStateResult) {
        return;
      }

      const { contentState } = contentStateResult;

      // Create new editor state
      const newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

      // Set decorator and editor state
      if (memoizedDecorator) {
        // FIXED: Only update decorator if it actually changed
        if (JSON.stringify(editorState.getDecorator()) !== JSON.stringify(memoizedDecorator)) {
          setInitialDecorator(memoizedDecorator);
          setEditorState(EditorState.set(newEditorState, { decorator: memoizedDecorator }));
        } else {
          setEditorState(newEditorState);
        }
      }

      // Blur editor
      if (editorRef.current) {
        editorRef.current.blur();
      }
    }, 500); // 500ms debounce

    // Cleanup function to clear timeout if component unmounts or dependencies change
    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    // FIXED: Only depend on essential values, not entire objects
    selectedIndicators?.formula,
    // Only rebuild when the formula map structure changes, not the content
    selectedIndicators?.calculated_formula?.formula_map?.length || 0,
    // Only rebuild when decorator strategies types change
    Object.keys(decoratorStrategies).length,
    // REMOVED: processFormulaData, createContentStateWithEntities, memoizedDecorator
    // These were causing unnecessary re-runs
  ]);

  const handleKeyCommand = (command) => {
    if (command === 'split-block') {
      // 'split-block' corresponds to the Enter key
      return 'handled'; // Prevent the default behavior of adding a new line
    }
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      setEditorState(newState);
      return 'handled';
    }
    return 'not-handled';
  };

  const handleBeforeInput = (chars) => {
    const bracketsMap = {
      '{': '}',
      '[': ']',
      '(': ')',
      '"': '"',
      "'": "'",
    };

    if (bracketsMap[chars]) {
      const currentContent = editorState.getCurrentContent();
      const selection = editorState.getSelection();

      const newContent = Modifier.insertText(currentContent, selection, chars + bracketsMap[chars]);

      const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      setEditorState(
        EditorState.forceSelection(
          newEditorState,
          newContent
            .getSelectionAfter()
            .set('anchorOffset', selection.getAnchorOffset() + 1)
            .set('focusOffset', selection.getAnchorOffset() + 1),
        ),
      );
      return 'handled';
    }

    return 'not-handled';
  };
  const [isDimensionItemsShow, setIsDimensionItemsShow] = useState(false);
  const isCursorInsideBrackets = (text, cursorIndex) => {
    const openingIndex = text.lastIndexOf('[', cursorIndex);
    const closingIndex = text.indexOf(']', cursorIndex);
    // Check if both indices are valid and the cursor is between them
    return (
      openingIndex !== -1 &&
      closingIndex !== -1 &&
      openingIndex < cursorIndex &&
      closingIndex > cursorIndex
    );
  };

  const handleChange = (state) => {
    if (isExpanded) {
      const contentState = state.getCurrentContent();
      const selection = state.getSelection();
      const anchorKey = selection.getAnchorKey();
      const currentContentBlock = contentState.getBlockForKey(anchorKey);
      const blockText = currentContentBlock.getText();
      const blockTextUntilCursor = blockText.slice(0, selection.getAnchorOffset());
      const focusOffset = selection?.getFocusOffset();
      // Check if the content is empty
      if (blockText === '' && blockTextUntilCursor === '') {
        // Clear filtered suggestions and handle the empty state
        setShowSuggestions(false);
        setEditorState(state);

        // Adjust the height of the editor container
        const editorContainer = editorContainerRef.current;
        if (editorContainer) {
          editorContainer.style.height = 'auto';
          editorContainer.style.height = `${editorContainer.scrollHeight}px`;
        }
        return;
      }

      // Regex to capture the last typed word or phrase
      const lastWordMatch = blockTextUntilCursor.match(/(\b\w+\b)$/);
      const isDimItemShow = isCursorInsideBrackets(`${blockText}`, focusOffset - 1);
      setIsDimensionItemsShow(isDimItemShow);
      if (lastWordMatch) {
        const lastPhrase = lastWordMatch[0]?.trim();
        const filteredSuggestions = suggestions?.filter((suggestion) => {
          if (typeof suggestion === 'string') {
            return suggestion?.toLowerCase().includes(lastPhrase?.toLowerCase());
          }
          switch (suggestion.type) {
            case 'function': {
              return suggestion?.name.toLowerCase()?.includes(lastPhrase?.toLowerCase());
            }
            case 'othersblockIndicator': {
              const fullBlockIndicatorName = `${suggestion?.blockname} . ${suggestion?.indicator}`
                .trim()
                .toLowerCase();
              return fullBlockIndicatorName?.toLowerCase()?.includes(lastPhrase.toLowerCase());
            }

            case 'dimension': {
              const fullDimensionName = `${suggestion?.dimName} . ${suggestion?.dimPropertie}`
                .trim()
                .toLowerCase();
              return fullDimensionName?.toLowerCase()?.includes(lastPhrase.toLowerCase());
            }
            case 'dimensionItem': {
              const fullDimensionItem = `${suggestion?.dimName} . ${suggestion?.dimItem}`
                .trim()
                .toLowerCase();
              return fullDimensionItem?.toLowerCase()?.includes(lastPhrase.toLowerCase());
            }

            case 'dimensionValue': {
              const fullDimensionValue = `${suggestion?.dimValue}`.trim().toLowerCase();
              return fullDimensionValue?.toLowerCase()?.includes(lastPhrase.toLowerCase());
            }

            case 'currentBlockIndicator': {
              return suggestion?.indName.toLowerCase()?.includes(lastPhrase?.toLowerCase());
            }

            default:
              return false;
          }
        });
        setSuggestionsList(filteredSuggestions);
        setShowSuggestions(true);
      } else {
        // No last word match, handle as needed
        setShowSuggestions(false);
      }

      setEditorState(state);

      // Adjust the height of the editor container
      const editorContainer = editorContainerRef.current;
      if (editorContainer) {
        editorContainer.style.height = 'auto';
        editorContainer.style.height = `${editorContainer.scrollHeight}px`;
      }
    }
  };

  useEffect(() => {
    if (isExpanded === true) {
      const editorContainer = editorContainerRef.current;
      if (editorContainer) {
        editorContainer.style.height = 'auto';
        editorContainer.style.height = `${editorContainer.scrollHeight}px + '25px`;
        editorContainer.style.width = `100%`;
      }
    }
  }, [editorState, isExpanded]);

  const handleSuggestionClick = (suggestion) => {
    if (isExpanded) {
      const entityKey = createEntity(suggestion?.type);
      const currentContent = editorState?.getCurrentContent();
      const selection = editorState?.getSelection();
      const anchorOffset = selection?.getAnchorOffset();
      const focusOffset = selection?.getFocusOffset();
      const startOffset = Math?.min(anchorOffset, focusOffset);
      const endOffset = Math?.max(anchorOffset, focusOffset);

      const blockKey = selection?.getAnchorKey();
      const block = currentContent?.getBlockForKey(blockKey);
      const blockText = block?.getText();
      const blockTextBeforeCursor = blockText?.slice(0, startOffset);
      const lastWordMatch = blockTextBeforeCursor?.match(/(\w+)$/);
      const lastWordStart = lastWordMatch ? lastWordMatch?.index : startOffset;
      const suggestionText =
        typeof suggestion === 'string'
          ? suggestion
          : suggestion?.type === 'function'
          ? `${suggestion?.name}`
          : suggestion?.type === 'othersblockIndicator'
          ? `${suggestion?.blockname} . ${suggestion?.indicator}`
          : suggestion?.type === 'dimension'
          ? `${suggestion?.dimName} . ${suggestion?.dimPropertie}`
          : suggestion?.type === 'dimensionItem'
          ? `${suggestion?.dimName} . ${suggestion?.dimItem}`
          : suggestion?.type === 'dimensionValue'
          ? `${suggestion?.dimValue}`
          : suggestion?.type === 'currentBlockIndicator'
          ? `${suggestion?.indName}`
          : '';
      const newContent = Modifier?.replaceText(
        currentContent,
        selection.merge({
          anchorOffset: lastWordStart,
          focusOffset: endOffset,
        }),
        suggestionText,
        null, // Entity type
        entityKey,
      );
      let newEditorState = EditorState?.push(editorState, newContent, 'insert-characters');
      const combinedDecorator = createCombinedDecorator(suggestion.type);
      newEditorState = EditorState?.set(newEditorState, { decorator: combinedDecorator });
      // // Apply the new editor state with the combined decorator
      // setEditorState(
      //   EditorState.set(newEditorState, { decorator: combinedDecorator })
      // );
      setEditorState(
        EditorState.forceSelection(
          newEditorState,
          newContent
            .getSelectionAfter()
            .set('anchorOffset', lastWordStart + suggestionText.length)
            .set('focusOffset', lastWordStart + suggestionText.length),
        ),
      );

      setShowSuggestions(false);

      setTimeout(() => {
        editorRef.current.focus();
      }, 0);
    }
  };
  const renderSuggestions = () => {
    // Check if there's any content for each section
    const hasCurrentBlockIndicators = suggestionsList?.some(
      (suggestion) => suggestion?.type === 'currentBlockIndicator',
    );
    const hasOtherBlockIndicators = suggestionsList?.some(
      (suggestion) => suggestion?.type === 'othersblockIndicator',
    );
    const hasDimensions = suggestionsList?.some((suggestion) => suggestion?.type === 'dimension');
    const hasDimensionsItems = suggestionsList?.some(
      (suggestion) => suggestion?.type === 'dimensionItem',
    );
    // const hasDimensionsValues = suggestionsList?.some(
    //   (suggestion) => suggestion?.type === 'dimensionValue',
    // );
    const hasFunctions = suggestionsList?.some((suggestion) => suggestion?.type === 'function');

    return (
      <div>
        {hasCurrentBlockIndicators && (
          <Box borderBottom={'1px solid grey'} p={3}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Indicators in this block
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion?.type === 'currentBlockIndicator')
              ?.map((suggestion, index) => (
                <Box
                  px={2}
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  cursor={'pointer'}
                  width={'100%'}
                >
                  <Text
                    className='currBlockIndicator-currentBlockIndicator'
                    width={'fit-content'}
                    color={'black'}
                    px={'1rem'}
                  >
                    {suggestion?.indName}
                  </Text>
                </Box>
              ))}
          </Box>
        )}

        {hasOtherBlockIndicators && (
          <Box p={3} borderBottom={'1px solid grey'}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Indicators in other blocks
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion?.type === 'othersblockIndicator')
              ?.map((suggestion, index) => (
                <Box
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  cursor={'pointer'}
                >
                  <Text>
                    <span
                      className='blockname-othersblockIndicator'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.blockname}
                    </span>{' '}
                    <span
                      className='blockname-othersblockIndicator'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.indicator}
                    </span>
                  </Text>
                </Box>
              ))}
          </Box>
        )}

        {hasDimensions && (
          <Box p={3} borderBottom={'1px solid grey'}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Dimensions properties
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion?.type === 'dimension')
              ?.map((suggestion, index) => (
                <Box
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  cursor={'pointer'}
                >
                  <Text>
                    <span
                      className='dimeItem-dimension'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.dimName}
                    </span>{' '}
                    <span
                      className='dimeItem-dimension'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.dimPropertie}
                    </span>
                  </Text>
                </Box>
              ))}
          </Box>
        )}

        {isDimensionItemsShow === true && hasDimensionsItems && (
          <Box p={3} borderBottom={'1px solid grey'}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Dimensions Items
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion?.type === 'dimensionItem')
              ?.map((suggestion, index) => (
                <Box
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  cursor={'pointer'}
                >
                  <Text>
                    <span
                      className='dimeItem-dimensionItem'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.dimName}
                    </span>{' '}
                    <span
                      className='dimeItem-dimensionItem'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.dimItem}
                    </span>
                  </Text>
                </Box>
              ))}
          </Box>
        )}

        {/* {hasDimensionsValues && (
          <Box p={3} borderBottom={'1px solid grey'}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Dimensions Values
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion?.type === 'dimensionValue')
              ?.map((suggestion, index) => (
                <Box
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  cursor={'pointer'}
                >
                  <Text>
                    <span
                      className='dimensionValue-dimensionValue'
                      style={{ width: 'fit-content', paddingLeft: '1rem', paddingRight: '1rem' }}
                    >
                      {suggestion?.dimValue}
                    </span>
                  </Text>
                </Box>
              ))}
          </Box>
        )} */}

        {hasFunctions && (
          <Box p={3} borderBottom={'1px solid grey'}>
            <Text
              className='formula-list-ignore'
              fontSize={'14px'}
              fontWeight={'600'}
              mb={2}
              color={'black'}
            >
              Functions
            </Text>
            {suggestionsList
              ?.filter((suggestion) => suggestion.type === 'function')
              ?.map((suggestion, index) => (
                <Box
                  px={2}
                  key={index}
                  className={`suggestion-item`}
                  onClick={() => handleSuggestionClick(suggestion)}
                  py={'0.5rem'}
                  width={'100%'}
                  cursor={'pointer'}
                >
                  <Text
                    width={'fit-content'}
                    className='function-function'
                    px={'1rem'}
                    color={'black'}
                  >
                    {suggestion?.name}
                  </Text>
                </Box>
              ))}
          </Box>
        )}
      </div>
    );
  };
  // It fetches Indicator data + block metadata after submitting formula
  // so tables pick up the latest formula at runtime.
  const fetchIndicatorsData = () => {
    const idArray = plannerBlock?.dimensions
      ?.filter((item) => item?.name !== 'Time')
      ?.map((item) => item?.id);
    const dimensionIds = idArray?.join(', ');
    const payload = {
      blockId,
      params: {
        dim_id: dimensionIds,
        indicator_filter: 'all',
        scenario_id: baseScenario?.id,
      },
    };
    dispatch(FetchBlockOutputs(payload));

    if (blockId && baseScenario?.id) {
      const metadataPayload = {
        blockId: Number(blockId),
        parameters: { scenario_id: baseScenario.id },
      };
      dispatch(FetchPlannerBlockMetadata(metadataPayload));
      // dispatch(fetchBuilderBlockMetadata(metadataPayload));
    }
  };
  const handleFieldChanges = async (updatedFormula) => {
    const indicatorFormula = await dispatch(
      UpdateIndicatorFormula({
        indicatorId: selectedIndicators?.id,
        data: {
          formula: updatedFormula,
        },
      }),
    );
    if (indicatorFormula?.error) {
      fetchIndicatorsData();
      setMessage({ type: 'error', text: indicatorFormula?.payload, errorStatus: true });
    } else {
      fetchIndicatorsData();
      setMessage({ type: 'success', text: 'Formula parsed successfully', errorStatus: false });
      setTimeout(() => {
        setMessage({ type: '', text: '', errorStatus: false });
      }, 4000);
    }
    setIsExpanded(false);
  };
  const handleReturn = () => {
    const contentState = editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    // Extract blocks and entityMap from raw content
    const { blocks, entityMap } = rawContent;
    // Initialize an array to hold the formatted text
    let formattedText = '';
    blocks.forEach((block) => {
      const blockText = block.text;
      const entities = block.entityRanges;
      // Sort entityRanges by their start offset to maintain correct order
      entities.sort((a, b) => a.offset - b.offset);
      let currentOffset = 0;
      entities.forEach((entityRange) => {
        const { offset, length, key } = entityRange;
        const entity = entityMap[key];
        // Append text before this entity
        if (offset > currentOffset) {
          formattedText += blockText.slice(currentOffset, offset);
        }
        // Append entity text with formatting
        const entityText = blockText.slice(offset, offset + length);
        const entityType = entity.data.type;
        // Apply formatting based on entity type
        if (entityType === 'othersblockIndicator') {
          formattedText += `'${entityText}'`;
        } else if (entityType === 'dimension') {
          formattedText += `'${entityText}'`;
        } else if (entityType === 'dimensionItem') {
          formattedText += `'${entityText}'`;
        } else if (entityType === 'dimensionValue') {
          formattedText += `'${entityText}'`;
        } else if (entityType === 'currentBlockIndicator') {
          formattedText += `'${entityText}'`;
        } else if (entityType === 'function') {
          formattedText += `'${entityText}'`;
        } else if (entityType === undefined) {
          formattedText += `'${entityText}'`;
        }
        // Update currentOffset
        currentOffset = offset + length;
      });
      // Append any remaining text after the last entity
      if (currentOffset < blockText.length) {
        formattedText += blockText.slice(currentOffset);
      }
      // // Add a space or delimiter between blocks if necessary
      // formattedText += 'a';
    });
    formattedText = formattedText
      .split(' . ')
      .map((segment, index) => (index === 0 ? `${segment}'` : `'${segment}'`))
      .join('.');
    // Remove the trailing space and log the result
    formattedText = formattedText
      .trim()
      .replace(/(?=\s)/g, '')
      .slice(0, -1);
    const output = formattedText;
    handleFieldChanges(output);
    setShowSuggestions(false);
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // Allow Shift + Enter to create a new line
        const newState = RichUtils.insertSoftNewline(editorState);
        setEditorState(newState);
      } else {
        handleReturn();
      }
      e.preventDefault(); // Prevent the default behavior (like inserting a new line)
    } else if (e.key === 'Escape') {
      setIsExpanded(false);
      e.preventDefault(); // Prevent the default behavior
    }
  };

  return (
    <Flex
      display={'flex'}
      justifyContent={'start'}
      alignItems={'center'}
      width={'100%'}
      transition='width 0.3s ease-in-out'
    >
      <FunctionIconComponent
        color='white'
        style={{ margin: '0 10px 0 15px', height: 30, minWidth: 30 }}
      />
      {isWorkerProcessing && (
        <Box
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          zIndex={1001}
          bg='rgba(0, 0, 0, 0.7)'
          color='white'
          px={3}
          py={2}
          borderRadius='md'
          fontSize='sm'
        >
          Processing formula data...
        </Box>
      )}
      <div
        className={`${isExpanded ? 'editor-container1' : 'editor-container'}`}
        style={{
          position: 'relative',
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <div
          ref={editorContainerRef}
          style={{
            transition: 'width 0.3s ease-in-out',
            marginTop: isExpanded ? '25px' : '0px',
          }}
          onKeyDown={handleKeyDown}
        >
          <Tooltip label={isExpanded ? '' : tooltipContent} hasArrow>
            <Flex
              alignItems={'center'}
              className={'editor'}
              onClick={() => setIsExpanded(true)}
              width={isExpanded ? '100%' : '90%'}
              transition='width 0.6s ease-in-out'
              border={`1px solid ${message?.errorStatus ? 'red' : '#ccc'}`}
            >
              <Editor
                editorState={editorState}
                handleKeyCommand={handleKeyCommand}
                handleBeforeInput={handleBeforeInput}
                onChange={handleChange}
                // handleKeyDown={handleKeyDown}
                editorRef={editorRef}
                readOnly={isExpanded !== true}
              />
              {isExpanded && (
                <Link href='https://blox.tawk.help/category/formulas/blox-functions' isExternal>
                  <QuestionIcon />
                </Link>
              )}
            </Flex>
          </Tooltip>

          <Flex display='flex' justifyItems={'center'} justifyContent={'space-between'}>
            <Flex display='flex' justifyItems={'center'}>
              {message?.errorStatus && message?.type === 'error' && (
                <Text color={'red'}>{message?.text}</Text>
              )}
              {message?.type === 'success' && <Text color={'green'}>Formula Submitted</Text>}
            </Flex>
            {isExpanded && (
              <Flex justifyContent='center'>
                <Text color='white'>
                  <Text as='span' fontWeight='bold'>
                    Enter
                  </Text>{' '}
                  to Submit,
                </Text>
                <Text color='white'>
                  <Text as='span' fontWeight='bold'>
                    &nbsp;Shift+Enter
                  </Text>{' '}
                  to add a new line
                </Text>
              </Flex>
            )}
          </Flex>
          {showSuggestions && (
            <div
              className='suggestion-box'
              style={{
                ...suggestionBoxStyle,
                position: 'fixed',
                zIndex: 1000,
                width: '50%',
                backgroundColor: 'white',
                // border: '1px solid #ccc',
                maxHeight: '350px',
                overflowY: 'auto',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '11px',
              }}
            >
              {renderSuggestions()}
            </div>
          )}
        </div>
      </div>
      {isExpanded && (
        <Button
          bgColor='#7163D0'
          ms={'1rem'}
          px={2}
          borderRadius={'4px'}
          border='1px solid transparent'
          outline='none'
          width='100px'
          height='40px'
          filter='drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25))'
          onClick={handleReturn}
        >
          Submit
        </Button>
      )}
    </Flex>
  );
};

export default DraftJSFormula2;
